import { inject } from "vue";
import { PoolDetails, ProbeDetails } from "@/models/pool-details.model";
import { Pool } from "@/models/pool.model";
import { Token } from "@/models/auth.models";
import { lastPool } from "@/features/pool/useLastPool";
import { useApi } from "@/services/useApi.ts";

const withToken = () => ({
  token: inject("token") as Token,
});

export const withPool = () => ({
  pool: inject("pool") as Pool,
  poolDetails: inject("poolDetails") as PoolDetails,
  refreshPool: inject("refreshPool") as () => Promise<void>,
  savePool: inject("savePool") as () => Promise<void>,
  isPoolDirty: inject("isPoolDirty") as boolean,
});

const withOut = () => ({
  out: inject("out") as Pool["outs"][number],
});

export const withProbe = () => ({
  probe: inject("probe") as ProbeDetails,
});

export const injectToken = {
  setup() {
    return { ...withToken(), lastPool };
  },
};

export const injectPool = {
  setup() {
    return { ...withToken(), ...withPool() };
  },
};

export const injectOut = {
  setup() {
    return { ...withToken(), ...withPool(), ...withOut() };
  },
};

export const injectProbe = {
  setup() {
    return {
      ...withToken(),
      ...withPool(),
      ...withOut(),
      ...withProbe(),
      api: useApi(),
    };
  },
};
